export enum ContentType {
  view = 'view',
  metric = 'metric',
  workbook = 'workbook',
  unifieddatasource = 'unifieddatasource',
  virtualconnection = 'virtualconnection',
  flow = 'flow',
  project = 'project',
  table = 'table',
  database = 'database',
  datarole = 'datarole',
  lens = 'lens',
  collection = 'collection',
  predictivemodel = 'predictivemodel',
}
// Some of the entries above don't use camel case since we use those entries to map to
// the content type names in the backend and those content type names don't use camel case.
